import SessionEventProto from "../session-event-proto"
import {MyWorkType} from "../../../app/home/my-work/common/model/@const"
import MyWorkCollection from "../../../app/home/my-work/common/model/my-work-collection"

export default class SessionEvent_MyWorkDelete extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        if (this.isDifferentCompany()) {
            return
        }

        if (!gd.session.myWork) return

        try {
            const myWork = (gd.session.myWork as MyWorkCollection).get(this.data.id)
            gd.session.myWork.remove(myWork)
            gd.bus.triggerEvent('gd.session.myWork:remove')

            if (myWork?.type === MyWorkType.TODO) {
                gd.modelBus.newUpdate('my-work-todo', 'delete', this.data.id, _.assign({}, this.data), {
                    todo        : this.data,
                    isBulkUpdate: true,
                })
            }
        } catch (err) {
            gd.utils.captureErrorMessage('EventMyWorkDelete error', {
                level: 'error',
                extra: {
                    this : this,
                    error: err,
                }
            })
        }
    }

}
